export default "__VITE_ASSET__BEvu9TIL__"